export const DOCTOR_ROLE_DEFINITIONS = [
    { key: 'examination', label: 'Bác sĩ khám', relation: 'examination_doctors' },
    { key: 'treatment', label: 'Bác sĩ điều trị', relation: 'treatment_doctors' },
    { key: 'implant_placement', label: 'Bác sĩ cắm trụ', relation: 'implant_doctors', implantOnly: true },
    { key: 'prosthetic_restoration', label: 'Bác sĩ phục hình', relation: 'prosthetic_doctors', implantOnly: true },
    { key: 'apprentice', label: 'Bác sĩ học việc', relation: 'apprentice_doctors' },
];

const uniquePeople = (rows = []) => {
    const people = new Map();
    (rows || []).forEach(row => {
        const user = row?.doctor || row?.employee || row;
        const id = Number(user?.id ?? row?.employee_id ?? row?.doctor_id) || null;
        const name = user?.full_name || row?.full_name || row?.display_name || null;
        if (!name) return;
        people.set(id ? `id:${id}` : `name:${name}`, { id, name });
    });
    return Array.from(people.values());
};

const hasNewRoleData = service => DOCTOR_ROLE_DEFINITIONS.some(role => (service?.[role.relation] || []).length > 0);

/** Chuẩn hóa role bác sĩ của Customer Service; legacy chỉ dùng khi API chưa có contract mới. */
export const getCustomerServiceDoctorRoleGroups = (service = {}, { includeEmpty = false } = {}) => {
    const isImplant = service?.service?.service_group?.code === 'implant'
        || service?.service_group?.code === 'implant'
        || service?.service_group === 'implant';
    const useNewContract = hasNewRoleData(service);

    const groups = DOCTOR_ROLE_DEFINITIONS
        .filter(role => !role.implantOnly || isImplant)
        .map(role => ({ ...role, people: uniquePeople(service?.[role.relation] || []) }));

    if (!useNewContract) {
        const legacy = service?.doctors || [];
        const treatment = legacy.filter(row => !Number(row?.is_apprentice ?? row?.meta_json?.is_apprentice));
        const replacements = {
            treatment: treatment,
            implant_placement: legacy.filter(row => Number(row?.is_implant_doctor ?? row?.meta_json?.is_implant_doctor) === 1),
            prosthetic_restoration: legacy.filter(row => Number(row?.is_prosthetic ?? row?.meta_json?.is_prosthetic) === 1),
            apprentice: legacy.filter(row => Number(row?.is_apprentice ?? row?.meta_json?.is_apprentice) === 1 || row?.assignment_kind === 'APPRENTICE'),
        };
        groups.forEach(group => { group.people = uniquePeople(replacements[group.key] || []); });
    }

    return includeEmpty ? groups : groups.filter(group => group.people.length > 0);
};

/** Chuẩn hóa snapshot bốn vai trò bác sĩ của lịch hẹn. */
export const getAppointmentDoctorRoleGroups = (appointmentService = {}, { includeEmpty = false } = {}) => {
    const rows = appointmentService?.doctors || [];
    const pivotValue = (row, key) => Number(row?.pivot?.[key] ?? row?.[key]) === 1;
    const isImplant = appointmentService?.customer_service?.service?.service_group?.code === 'implant'
        || rows.some(row => pivotValue(row, 'is_implant_doctor') || pivotValue(row, 'is_prosthetic'));
    const groups = [
        { key: 'examination', label: 'Bác sĩ khám', people: uniquePeople(rows.filter(row => pivotValue(row, 'is_examination_doctor'))) },
        { key: 'treatment', label: 'Bác sĩ điều trị', people: uniquePeople(rows.filter(row =>
            pivotValue(row, 'is_treatment_doctor') || (!('is_treatment_doctor' in (row?.pivot || row)) && !pivotValue(row, 'is_apprentice'))
        )) },
        ...(isImplant ? [
            { key: 'implant_placement', label: 'Bác sĩ cắm trụ', people: uniquePeople(rows.filter(row => pivotValue(row, 'is_implant_doctor'))) },
            { key: 'prosthetic_restoration', label: 'Bác sĩ phục hình', people: uniquePeople(rows.filter(row => pivotValue(row, 'is_prosthetic'))) },
        ] : []),
    ];
    return includeEmpty ? groups : groups.filter(group => group.people.length > 0);
};

export const doctorRoleGroupsText = groups => (groups || [])
    .map(group => `${group.label}: ${group.people.map(person => person.name).join(', ')}`)
    .join('; ');
